// Roles
const ROLES = {
  Admin: "Admin",
  ClinicAdmin: "ClinicAdmin",
  ClinicUser: "CU",
  Doctor: "Doc",
  Physician: "Physician",
  PowerUser: "PU",
  RadiologistUser: 'RDU',
  ReferringDoctor: 'RefDoc',
  SharedDoctor: 'SDD',
  SharedPatient: 'SDP',
  SuperAdmin: "SuperAdmin",
  TechnicianUser: "TCU"
}

export default ROLES
